/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import {
  AppGitUpdateInput,
  AppGitUpdateInput$Outbound,
  AppGitUpdateInput$outboundSchema,
} from "./appgitupdateinput.js";
import { AppOCI, AppOCI$Outbound, AppOCI$outboundSchema } from "./appoci.js";

/**
 * Provide at least one field to update. Omitted fields remain unchanged.
 */
export type V1AppsUpdateAppRequestBody = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  project: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  app: string;
  /**
   * New human-readable name for the app.
   *
   * @remarks
   * Omit this field to leave the current name unchanged.
   */
  name?: string | undefined;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  slug?: string | undefined;
  /**
   * Connect, reconfigure, or disconnect this app's GitHub repository.
   *
   * @remarks
   * Omit to leave unchanged, set null to disconnect, or set an object with a
   * "repository" to connect or replace it and/or a "defaultBranch" to set which
   * branch it tracks. Fields are independent, so send only the one you change.
   */
  git?: AppGitUpdateInput | null | undefined;
  /**
   * Change the default image reference for an OCI-sourced app. This does not
   *
   * @remarks
   * create a deployment. It can be combined with other app settings. Source
   * switching is not supported.
   */
  oci?: AppOCI | undefined;
  /**
   * Enable or disable delete protection for the app.
   *
   * @remarks
   * Omit this field to leave the current setting unchanged.
   */
  deleteProtection?: boolean | undefined;
};

/** @internal */
export type V1AppsUpdateAppRequestBody$Outbound = {
  project: string;
  app: string;
  name?: string | undefined;
  slug?: string | undefined;
  git?: AppGitUpdateInput$Outbound | null | undefined;
  oci?: AppOCI$Outbound | undefined;
  deleteProtection?: boolean | undefined;
};

/** @internal */
export const V1AppsUpdateAppRequestBody$outboundSchema: z.ZodType<
  V1AppsUpdateAppRequestBody$Outbound,
  z.ZodTypeDef,
  V1AppsUpdateAppRequestBody
> = z.object({
  project: z.string(),
  app: z.string(),
  name: z.string().optional(),
  slug: z.string().optional(),
  git: z.nullable(AppGitUpdateInput$outboundSchema).optional(),
  oci: AppOCI$outboundSchema.optional(),
  deleteProtection: z.boolean().optional(),
});

export function v1AppsUpdateAppRequestBodyToJSON(
  v1AppsUpdateAppRequestBody: V1AppsUpdateAppRequestBody,
): string {
  return JSON.stringify(
    V1AppsUpdateAppRequestBody$outboundSchema.parse(v1AppsUpdateAppRequestBody),
  );
}
